<template>
    <div class="page-layout blank contacts-manage ml-4 mr-4">
        <!-- Breadcrumb section -->
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 d-flex justify-content-between align-items-center">
                <div class="breadcrumbnew">
                    <div><router-link to="/salesDashboard" class="text-white pl-2 text-line">Sales Dashboard</router-link></div>
                    <span>Forecast</span>
                </div>
                <button type="button" v-if="loggedInUser.user_role == 'sales_manager' && userPermissions.sales_forecast.permitted_actions.create" class="btn btn-smm text-white create-forecast-btn ml-3" @click="showSalesForecast" >
                    <i class="icon icon-plus fs-12 text-white" style="color: #fff !important;"></i>
                    Create New Forecast
                </button>
            </div>
        </div>
        <div class="d-flex align-items-center justify-content-center" v-if="loadDashboardPage" style="height: 70% !important;">
            <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
        </div>
        <div v-else class="row">
            <!-- Sales Forecast Summary Section -->
            <div class="col-lg-8 col-md-8 col-sm-12 pr-0 connection-box">
                <fullscreen class="mr-4 box-radius bg-white" ref="summary"  style="height: 300px !important;" @change="dataChange('summary')" >
                    <div class="bg-white mb-4 box-radius">
                        <div class="d-flex justify-content-between aline-items-center p-4">
                            <div class="fw-600 fs-14">Forecast Summary</div>
                            <button type="button" class="pointer bg-white icon-outline-css" @click="expandData('summary')">
                                <img class="expand-img" src="/static/images/dashboard/expand_logo.svg" alt />
                            </button>
                        </div>
                        <div v-if="forecast_data.length == 0" class="row" style="min-height: 500px;">
                            <div class="d-flex justify-content-center align-items-center w-100" >
                                <img src="/static/images/survey-type.png" class="mb-3" style="width: 45%!important"/>
                            </div>
                            <div class="justify-content-center align-items-center w-100 pl-10">
                                <div class="text-center text-muted fw-500 align-text">No forecast summary!</div>
                            </div>
                        </div>
                        <div v-else class="row">
                                <div class="col-lg-4 col-md-4 col-sm-12">
                                    <div id="forecastSummaryChartDiv"></div>
                                </div>
                                <div id="legenddiv" class="pr-0 connection-box"></div>
                                <div class="col-lg-8 col-md-8 col-sm-12 table-div">
                                    <table class="table table-responsive forecast-table">
                                        <thead  v-if="forecast_data.length != 0" >
                                            <th class="w-1 whiteSpace pr-18">Forecast Period</th>
                                            <th class="whiteSpace">Target ({{currency}})</th>
                                            <th class="whiteSpace pr-10">Territory</th>
                                            <th class="whiteSpace">Country</th>
                                        </thead>
                                        <tbody>
                                            <tr v-if="ajaxCallInProgress && !forecast_data.length">
                                                <td colspan="15">
                                                    <div class="d-flex align-items-center justify-content-center w-100"
                                                        v-if="ajaxCallInProgress">
                                                        <half-circle-spinner :animation-duration="1000" :size="50"
                                                            color="#00448b" style="margin: 0 auto;" />
                                                    </div>
                                                </td>
                                            </tr>
                                            <!-- <tr v-else-if="!ajaxCallInProgress && forecast_data.length == 0" class="text-center">
                                                <td colspan="15">
                                                    <img src="/static/images/survey-type.png" class="mb-3 mt-5 response-list"/>
                                                    <div class="ml-4 mt-5">No forecast summary!</div>
                                                </td>
                                            </tr> -->
                                            <tr class="forecast-table-row" v-else v-for="(data, i) in forecast_data" :key="data.territory_id" v-on:click="selectItem(i)" v-bind:class="{ active: i === activeItem }">
                                                <td class="pointer text-new-blue" @click="loadTerritory(data)">{{data.fiscal_year}}</td>
                                                <td>{{data.target}}</td>
                                                <td>{{data.territory}}</td>
                                                <td>
                                                    <div >
                                                        <span>{{data.country_count ? data.country[0] : "-"}}</span>
                                                        <el-popover class="forecast-country"
                                                            v-if="data.country.length > 1"
                                                            placement="bottom"
                                                            width="100"
                                                            trigger="hover">
                                                            <div v-for="(country, index) in data.country" :key="index">
                                                                <span class="fw-500">{{country}}</span>
                                                            </div>
                                                            <el-button slot="reference">
                                                                <span class="fw-500 mt-4 text-center text-secondary">
                                                                    +{{data.country_count - 1}}
                                                                </span>
                                                            </el-button>
                                                        </el-popover>
                                                    </div>
                                                </td>
                                                <!-- <td>{{data.country[0]}} <span v-if="data.country_count > 1">+{{data.country_count - 1}}</span></td> -->
                                            </tr>
                                        </tbody>

                                    </table>
                                </div>
                            <!-- </div> -->
                        </div>
                    </div>
                </fullscreen>
            </div>
            <!-- Sales Forecast Summary Country Selection Section -->
            <div class="col-lg-4 col-md-4 col-sm-12 pl-0 connection-box-bottom">
                <fullscreen class="box-radius bg-white" ref="country" @change="dataChange('country')">
                <div class="bg-white box-radius mb-4">
                    <div class="d-flex justify-content-between aline-items-center p-4">
                        <div class="fw-600">{{country_data.territory}}</div>
                        <div>
                            <label class="fw-600 fs-14">Country :</label>
                            <select class="country-size" v-model="selected_country" @change="loadForcastSummaryCountry(country_data.territory_id, selected_country)">
                                <option value="" disabled>Select Country</option>
                                <option v-for="data in country_data.country" :key="data">{{data}}</option>
                            </select>
                            <button type="button" class="pointer bg-white icon-outline-css" @click="expandData('country'), forecastSummaryTable()">
                                <img class="expand-img" src="/static/images/dashboard/expand_logo.svg" alt />
                            </button>
                        </div>
                    </div>
                    <table id = "forecast-summary-table" class="table table-responsive forecast-summary-table">
                        <thead v-if="country_data.length != 0">
                            <th class="w-1 whiteSpace forecast-period">Forecast Period</th>
                            <th class="whiteSpace target">Target ({{currency}})</th>
                            <th class="whiteSpace achieved">Achieved ({{currency}})</th>
                        </thead>
                        <template>
                            <tbody>
                                <tr class="w-100" v-if="ajaxCallInProgress && !country_data.length">
                                    <td colspan="15">
                                        <div class="d-flex align-items-center justify-content-center w-100"
                                            v-if="ajaxCallInProgress">
                                            <half-circle-spinner :animation-duration="1000" :size="50"
                                                color="#00448b" style="margin: 0 auto;" />
                                        </div>
                                    </td>
                                </tr>
                                <tr v-else-if="!ajaxCallInProgress && selected_country == ''"
                                    class="text-center">
                                    <td colspan="15" class="pt-28">
                                        <img src="/static/images/ongoing_survey.png" class="mb-3 response-list"/>
                                        <div class="ml-4 mt-5 text-muted fw-500">No data!</div>
                                    </td>
                                </tr>
                                <tr v-else>
                                    <td v-if='selected_country != ""'>
                                        <div class="text-secondary pointer d-flex align-items-center">
                                            <span @click="showRequest(country_data),loadForecastSummaryCountrySemiAnnualData(country_data.territory_id, selected_country)" class="pointer">
                                                <i v-if="country_data.expanded" class="icon icon-menu-down text-new-blue fs-28"></i>
                                                <i v-else class="icon icon-menu-right text-new-blue fs-28"></i>
                                            </span>
                                            <span class="text-capitalize">{{country_data.fiscal_year}}</span>
                                        </div>
                                        </td>
                                    <td>{{forecastCountry_data.forecast}}</td>
                                    <td>{{forecastCountry_data.actual}}</td>
                                </tr>
                            </tbody>
                            <transition name="fade">
                                <template>
                                    <tr v-if="country_data.expanded">
                                        <td class="pl-10">
                                            <div class="text-secondary pointer d-flex align-items-center">
                                                <span @click="showRequest(first_semi_annual_data),loadForecastSummaryFirstHalfQuarterData(country_data.territory_id, selected_country)" class="pointer">
                                                    <i v-if="first_semi_annual_data.expanded" class="icon icon-menu-down text-new-blue fs-28"></i>
                                                    <i v-else class="icon icon-menu-right text-new-blue fs-28"></i>
                                                </span>
                                                <span class="text-capitalize">{{first_semi_annual_data.half_year}}</span>
                                            </div>
                                        </td>
                                        <td>{{first_semi_annual_data.actual}}</td>
                                        <td>{{first_semi_annual_data.forecast}}</td>
                                    </tr>
                                </template>
                            </transition>
                            <transition name="fade">
                                <template>
                                    <tr v-if="first_semi_annual_data.expanded && country_data.expanded">
                                        <td class="pl-14">
                                            <div class="text-secondary pointer d-flex align-items-center">
                                                <span @click="showRequest(first_qurter_data),loadForecastSummaryFirstQuarterData(country_data.territory_id, selected_country)" class="pointer">
                                                    <i v-if="first_qurter_data.expanded" class="icon icon-menu-down text-new-blue fs-28"></i>
                                                    <i v-else class="icon icon-menu-right text-new-blue fs-28"></i>
                                                </span>
                                                <span class="text-capitalize">{{first_qurter_data.quarter}}</span>
                                            </div>
                                        </td>
                                        <td>{{first_qurter_data.actual}}</td>
                                        <td>{{first_qurter_data.forecast}}</td>
                                    </tr>
                                </template>
                            </transition>
                                    <transition name="fade">
                                        <tr v-if="first_qurter_data.expanded && first_semi_annual_data.expanded && country_data.expanded">
                                            <td class="pl-22 text-capitalize text-new-blue"><i class="icon icon-menu-right text-new-blue fs-28"></i>{{january_data.month}}</td>
                                            <td>{{january_data.actual}}</td>
                                            <td>{{january_data.forecast}}</td>
                                        </tr>
                                    </transition>
                                    <transition name="fade">
                                        <tr v-if="first_qurter_data.expanded && first_semi_annual_data.expanded && country_data.expanded">
                                            <td class="pl-22 text-capitalize text-new-blue"><i class="icon icon-menu-right text-new-blue fs-28"></i>{{february_data.month}}</td>
                                            <td>{{february_data.actual}}</td>
                                            <td>{{february_data.forecast}}</td>
                                        </tr>
                                    </transition>
                                    <transition name="fade">
                                        <tr v-if="first_qurter_data.expanded && first_semi_annual_data.expanded && country_data.expanded">
                                            <td class="pl-22 text-capitalize text-new-blue"><i class="icon icon-menu-right text-new-blue fs-28"></i>{{march_data.month}}</td>
                                            <td>{{march_data.actual}}</td>
                                            <td>{{march_data.forecast}}</td>
                                        </tr>
                                    </transition>
                                    <transition name="fade">
                                        <template>
                                            <tr v-if="first_semi_annual_data.expanded && country_data.expanded">
                                                <td class="pl-14">
                                                    <div class="text-secondary pointer d-flex align-items-center">
                                                        <span @click="showRequest(second_qurter_data),loadForecastSummarySecondQuarterData(country_data.territory_id, selected_country)" class="pointer">
                                                            <i v-if="second_qurter_data.expanded" class="icon icon-menu-down text-new-blue fs-28"></i>
                                                            <i v-else class="icon icon-menu-right text-new-blue fs-28"></i>
                                                        </span>
                                                        <span class="text-capitalize">{{second_qurter_data.quarter}}</span>
                                                    </div>
                                                </td>
                                                <td>{{second_qurter_data.actual}}</td>
                                                <td>{{second_qurter_data.forecast}}</td>
                                            </tr>
                                        </template>
                                    </transition>
                                    <transition name="fade">
                                        <tr v-if="second_qurter_data.expanded && first_semi_annual_data.expanded && country_data.expanded">
                                            <td class="pl-22 text-capitalize text-new-blue"><i class="icon icon-menu-right text-new-blue fs-28"></i>{{april_data.month}}</td>
                                            <td>{{april_data.actual}}</td>
                                            <td>{{april_data.forecast}}</td>
                                        </tr>
                                    </transition>
                                    <transition name="fade">
                                        <tr v-if="second_qurter_data.expanded && first_semi_annual_data.expanded && country_data.expanded">
                                            <td class="pl-22 text-capitalize text-new-blue"><i class="icon icon-menu-right text-new-blue fs-28"></i>{{may_data.month}}</td>
                                            <td>{{may_data.actual}}</td>
                                            <td>{{may_data.forecast}}</td>
                                        </tr>
                                    </transition>
                                    <transition name="fade">
                                        <tr v-if="second_qurter_data.expanded && first_semi_annual_data.expanded && country_data.expanded">
                                            <td class="pl-22 text-capitalize text-new-blue"><i class="icon icon-menu-right text-new-blue fs-28"></i>{{june_data.month}}</td>
                                            <td>{{june_data.actual}}</td>
                                            <td>{{june_data.forecast}}</td>
                                        </tr>
                                    </transition>
                            <transition name="fade">
                                <tr v-if="country_data.expanded">
                                    <td class="pl-10">
                                        <div class="text-secondary pointer d-flex align-items-center">
                                            <span @click="showRequest(second_semi_annual_data),loadForecastSummarySecondHalfQuarterData(country_data.territory_id, selected_country)" class="pointer">
                                                <i v-if="second_semi_annual_data.expanded" class="icon icon-menu-down text-new-blue fs-28"></i>
                                                <i v-else class="icon icon-menu-right text-new-blue fs-28"></i>
                                            </span>
                                            <span class="text-capitalize">{{second_semi_annual_data.half_year}}</span>
                                        </div>
                                    </td>
                                    <td>{{second_semi_annual_data.actual}}</td>
                                    <td>{{second_semi_annual_data.forecast}}</td>
                                </tr>
                            </transition>
                            <transition name="fade">
                                <template>
                                <tr v-if="second_semi_annual_data.expanded && country_data.expanded">
                                    <td class="pl-14">
                                        <div class="text-secondary pointer d-flex align-items-center">
                                                <span @click="showRequest(third_qurter_data),loadForecastSummaryThirdQuarterData(country_data.territory_id, selected_country)" class="pointer">
                                                    <i v-if="third_qurter_data.expanded" class="icon icon-menu-down text-new-blue fs-28"></i>
                                                    <i v-else class="icon icon-menu-right text-new-blue fs-28"></i>
                                                </span>
                                            <span class="text-capitalize">{{third_qurter_data.quarter}}</span>
                                        </div>
                                    </td>
                                    <td>{{third_qurter_data.actual}}</td>
                                    <td>{{third_qurter_data.forecast}}</td>
                                </tr>
                                </template>
                            </transition>
                                    <transition name="fade">
                                        <tr v-if="third_qurter_data.expanded && second_semi_annual_data.expanded && country_data.expanded">
                                            <td class="pl-22 text-capitalize text-new-blue"><i class="icon icon-menu-right text-new-blue fs-28"></i>{{july_data.month}}</td>
                                            <td>{{july_data.actual}}</td>
                                            <td>{{july_data.forecast}}</td>
                                        </tr>
                                    </transition>
                                    <transition name="fade">
                                        <tr v-if="third_qurter_data.expanded && second_semi_annual_data.expanded && country_data.expanded">
                                            <td class="pl-22 text-capitalize text-new-blue"><i class="icon icon-menu-right text-new-blue fs-28"></i>{{august_data.month}}</td>
                                            <td>{{august_data.actual}}</td>
                                            <td>{{august_data.forecast}}</td>
                                        </tr>
                                    </transition>
                                    <transition name="fade">
                                        <tr v-if="third_qurter_data.expanded && second_semi_annual_data.expanded && country_data.expanded">
                                            <td class="pl-22 text-capitalize text-new-blue"><i class="icon icon-menu-right text-new-blue fs-28"></i>{{september_data.month}}</td>
                                            <td>{{september_data.actual}}</td>
                                            <td>{{september_data.forecast}}</td>
                                        </tr>
                                    </transition>
                            <transition name="fade">
                                <template>
                                    <tr v-if="second_semi_annual_data.expanded && country_data.expanded">
                                        <td class="pl-14">
                                            <div class="text-secondary pointer d-flex align-items-center">
                                                <span @click="showRequest(fourth_qurter_data),loadForecastSummaryFourthQuarterData(country_data.territory_id, selected_country)" class="pointer">
                                                    <i v-if="fourth_qurter_data.expanded" class="icon icon-menu-down text-new-blue fs-28"></i>
                                                    <i v-else class="icon icon-menu-right text-new-blue fs-28"></i>
                                                </span>
                                                <span class="text-capitalize">{{fourth_qurter_data.quarter}}</span>
                                            </div>
                                        </td>
                                        <td>{{fourth_qurter_data.actual}}</td>
                                        <td>{{fourth_qurter_data.forecast}}</td>
                                    </tr>
                                </template>
                            </transition>
                                    <transition name="fade">
                                        <tr v-if="fourth_qurter_data.expanded && second_semi_annual_data.expanded && country_data.expanded">
                                            <td class="pl-22 text-capitalize text-new-blue"><i class="icon icon-menu-right text-new-blue fs-28"></i>{{october_data.month}}</td>
                                            <td>{{october_data.actual}}</td>
                                            <td>{{october_data.forecast}}</td>
                                        </tr>
                                    </transition>
                                    <transition name="fade">
                                        <tr v-if="fourth_qurter_data.expanded && second_semi_annual_data.expanded && country_data.expanded">
                                            <td class="pl-22 text-capitalize text-new-blue"><i class="icon icon-menu-right text-new-blue fs-28"></i>{{november_data.month}}</td>
                                            <td>{{november_data.actual}}</td>
                                            <td>{{november_data.forecast}}</td>
                                        </tr>
                                    </transition>
                                    <transition name="fade">
                                        <tr v-if="fourth_qurter_data.expanded && second_semi_annual_data.expanded && country_data.expanded">
                                            <td class="pl-22 text-capitalize text-new-blue"><i class="icon icon-menu-right text-new-blue fs-28"></i>{{december_data.month}}</td>
                                            <td>{{december_data.actual}}</td>
                                            <td>{{december_data.forecast}}</td>
                                        </tr>
                                    </transition>
                        </template>
                    </table>
                </div>
                </fullscreen>
            </div>
            <!-- Sales Forecast Products list view Section -->
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <div class="bg-white box-radius mb-8 p-4">
                    <div class="fw-600 fs-14">Product Forecast List</div>
                    <table class="table  mt-2  table-properties  w-100 forecast-list-table">
                        <thead v-if="forecast_list_data.length != 0">
                            <tr>
                                <th class="w-1 whiteSpace forecast-name">Forecast Name</th>
                                <th class="whiteSpace">Target ({{currency}})</th>
                                <th class="whiteSpace">Achieved ({{currency}})</th>
                                <th class="whiteSpace">Pipelines ({{currency}})</th>
                                <th class="whiteSpace sales-manager" v-if="loggedInUser.user_role == 'sales_manager'">Sales Manager</th>
                                <th class="whiteSpace team-lead" v-if="loggedInUser.user_role == 'sales_manager'">Team Lead</th>
                                <th class="whiteSpace sales-person" v-if="loggedInUser.user_role == 'sales_manager'">Sales Person</th>
                                <th class="whiteSpace" :class="{'territory':loggedInUser.user_role == 'sales_person' && loggedInUser.user_role == 'team_lead'}">Territory</th>
                                <th class="whiteSpace country" v-if="loggedInUser.user_role == 'sales_manager'">Country</th>
                                <th class="whiteSpace" :class="{'status':loggedInUser.user_role == 'sales_manager'}">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="w-100" v-if="ajaxCallInProgress && !forecast_list_data.length">
                                <td colspan="15">
                                    <div class="d-flex align-items-center justify-content-center w-100"
                                        v-if="ajaxCallInProgress">
                                        <half-circle-spinner :animation-duration="1000" :size="50"
                                            color="#00448b" style="margin: 0 auto;" />
                                    </div>
                                </td>
                            </tr>
                            <tr v-else-if="!ajaxCallInProgress && forecast_list_data.length == 0" class="text-center">
                                <td colspan="15">
                                    <img src="/static/images/territory-sales.png" class="mb-3 response-list"/>
                                    <div class="ml-4 mt-5 text-muted fw-500">No product forecast!</div>
                                </td>
                            </tr>
                            <tr v-else v-for="data in forecast_list_data" :key="data.id">
                                <td class="text-capitalize new-blue-text pointer" @click="selectedSalesForecast(data.id)">{{data.name}}</td>
                                <td>{{data.target}}</td>
                                <td>{{data.total_sales}}</td>
                                <td>{{data.margin}}</td>
                                <td v-if="data.hasOwnProperty('sales_people') && loggedInUser.user_role == 'sales_manager'">
                                    <span v-if="data.sales_manager != ''">
                                        {{data.sales_manager}}
                                    </span>
                                </td>
                                <td v-else-if="loggedInUser.user_role == 'sales_manager'">-</td>
                                <td v-if="data.hasOwnProperty('team_leads') && loggedInUser.user_role == 'sales_manager'">
                                    <span v-if="data.team_leads != ''">
                                        {{data.team_leads[0]}}
                                        <span v-if="data.team_lead_count > 1">
                                            +{{data.team_lead_count }}
                                        </span>
                                    </span>
                                </td>
                                <td v-else-if="loggedInUser.user_role == 'sales_manager'">-</td>
                                <td v-if="data.hasOwnProperty('sales_people') && loggedInUser.user_role == 'sales_manager'">
                                    <span v-if="data.sales_people != ''">
                                        {{data.sales_people[0]}}
                                        <span v-if="data.sales_people_count >1">
                                            +{{data.sales_people_count }}
                                        </span>
                                    </span>
                                </td>
                                <td v-else-if="loggedInUser.user_role == 'sales_manager'">-</td>
                                <td class="text-ellipsis pointer" :title="data.territory" v-if="data.territory != null">{{data.territory}}</td><td v-else>-</td>
                                <td v-if="data.country != '' && loggedInUser.user_role == 'sales_manager'">
                                    {{data.country}}
                                </td>
                                <td v-else-if="loggedInUser.user_role == 'sales_manager'">-</td>
                                <td v-if="data.status != ''">
                                    <span v-if="data.status == 'achieve'" class="achieved-btn">{{data.status.replace(/_/g, "")}}</span>
                                    <span v-else-if="data.status == 'un_achieved'" class="unachieve-btn">{{data.status.replace(/_/g, "")}}</span>
                                    <span v-else-if="data.status == 'un_assigned'" class="unassigned-btn">{{data.status.replace(/_/g, "")}}</span>
                                    <span v-else-if="data.status == 'active'" class="active-btn">{{data.status.replace(/_/g, "")}}</span>
                                    <span v-else-if="data.status == 'completed'" class="completed-btn">{{data.status.replace(/_/g, "")}}</span>
                                    <span v-else-if="data.status == 'need_to_assign'" class="need_to_assign-btn">{{data.status.replace(/_/g, " ")}}</span></td><td v-else>-</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
    </div>
</template>
<script>
import dashboard from '../mixins/dashboard'
import {SweetModal} from 'sweet-modal-vue';
import {HalfCircleSpinner} from "epic-spinners";
import {  EventBus } from '../eventBus/nav-bar-event';
export default {
    data(){
        return{
            loadDashboardPage: false,
            activeItem: null,
            forecast_data:[],
            forecastCountry_data:[],
            country_data: [],
            forecast_list_data: [],
            selected_country: "",
            first_semi_annual_data: [],
            second_semi_annual_data: [],
            first_qurter_data: [],
            second_qurter_data: [],
            third_qurter_data: [],
            fourth_qurter_data: [],
            january_data: [],
            february_data: [],
            march_data: [],
            april_data: [],
            may_data: [],
            june_data: [],
            july_data: [],
            august_data: [],
            september_data: [],
            october_data: [],
            november_data: [],
            december_data: [],
            warning_msg: '',
            success_msg: '',
            ajaxCallInProgress: false,
            currency:'',
        }
    },
    mixins:[dashboard],
    components: {
        SweetModal,
        HalfCircleSpinner
    },
    methods:{
        showSalesForecast(){
            this.$router.push('/salesForeCast/salesCast/list')
            setTimeout(() => {
                EventBus.$emit('showSalesForecastPopup',true)
            }, 2000);
        },
        selectItem(i) {
            this.activeItem = i;
        },
        forecastSummaryTable(){
            var summaryTable = document.getElementById('forecast-summary-table');
            summaryTable.classList.toggle('forecast-summary-table');
            summaryTable.classList.toggle('forecast-summary-table-expand');
        },
        expandData(value) {
            if(value == 'summary'){
                this.$refs["summary"].toggle();
            } else if(value == 'country'){
                this.$refs["country"].toggle();
                this.forecastSummaryTable();
            }
        },
        dataChange(value) {
            if(value == 'summary'){
                this.summary = value;
            } else if(value == 'country'){
                this.country = value;
                this.forecastSummaryTable();
            }
        },
        selectedSalesForecast(id) {
            this.$router.push("/salesForeCast/view_sales_forecast/"+id)
        },
        async showRequest(list){
            list.expanded = !list.expanded
            this.$forceUpdate()
        },
        //API call to load sales forecast summary data
        async loadForcastSummary(){
            let response = await this.getForecastSummaryData()
            this.forecast_data = response.response
            this.loadDashboardPage = false;
            // Create chart instance
            
            setTimeout(() => {
                var chart = am4core.create("forecastSummaryChartDiv", am4charts.PieChart);
            

                // Add data
                chart.data = this.forecast_data

                // Add and configure Series
                var pieSeries = chart.series.push(new am4charts.PieSeries());
                pieSeries.dataFields.value = "percentage";
                pieSeries.dataFields.category = "territory";

                // Let's cut a hole in our Pie chart the size of 40% the radius
                chart.innerRadius = am4core.percent(40);

                // Disable ticks and labels
                pieSeries.labels.template.disabled = true;
                pieSeries.ticks.template.disabled = true;

                // Disable tooltips
                pieSeries.slices.template.tooltipText = "";

                // Add a legend
                chart.legend = new am4charts.Legend();

                /* Create a separate container to put legend in */
                var legendContainer = am4core.create("legenddiv", am4core.Container);
                legendContainer.width = am4core.percent(100);
                legendContainer.height = am4core.percent(100);
                chart.legend.parent = legendContainer;
            }, 2000);
        },
        //API call to load selected forecast countries data
        async loadForcastSummaryCountry(id, country){
            let params = {
                territory_id: id,
                country: country,
                period: "fiscal_year"
            }
            let response = await this.getForecastSummaryCountryData(params)
            this.forecastCountry_data = response.response.sales_data
            // console.log(this.forecastCountry_data)
        },
        //API call to load forecast semi anual data
        async loadForecastSummaryCountrySemiAnnualData(id, country){
            let params = {
                territory_id: id,
                country: country,
                between: "h1",
                period: "semi_annual"
            }
            let response = await this.getForecastSummaryCountrySemiAnnualData(params)
            this.first_semi_annual_data = response.response.sales_data[0]
            this.second_semi_annual_data = response.response.sales_data[1]
        },
        //API call to load forecast first half year data
        async loadForecastSummaryFirstHalfQuarterData(id, country){
            let params = {
                territory_id: id,
                country: country,
                between: "h1",
                period: "quarter"
            }
            let response = await this.getForecastSummaryCountrySemiAnnualData(params)
            this.first_qurter_data = response.response.sales_data[0]
            this.second_qurter_data = response.response.sales_data[1]
        },
        //API call to load forecast second half year data
        async loadForecastSummarySecondHalfQuarterData(id, country){
            let params = {
                territory_id: id,
                country: country,
                between: "h2",
                period: "quarter"
            }
            let response = await this.getForecastSummaryCountrySemiAnnualData(params)
            this.third_qurter_data = response.response.sales_data[0]
            this.fourth_qurter_data = response.response.sales_data[1]
        },
        //API call to load forecast first quarter data
        async loadForecastSummaryFirstQuarterData(id, country){
            let params = {
                territory_id: id,
                country: country,
                between: "q1",
                period: "month"
            }
            let response = await this.getForecastSummaryCountrySemiAnnualData(params)
            this.january_data = response.response.sales_data[0]
            this.february_data = response.response.sales_data[1]
            this.march_data = response.response.sales_data[2]
        },
        //API call to load forecast second quarter data
        async loadForecastSummarySecondQuarterData(id, country){
            let params = {
                territory_id: id,
                country: country,
                between: "q2",
                period: "month"
            }
            let response = await this.getForecastSummaryCountrySemiAnnualData(params)
            this.april_data = response.response.sales_data[0]
            this.may_data = response.response.sales_data[1]
            this.june_data = response.response.sales_data[2]
        },
        //API call to load forecast third quarter data
        async loadForecastSummaryThirdQuarterData(id, country){
            let params = {
                territory_id: id,
                country: country,
                between: "q3",
                period: "month"
            }
            let response = await this.getForecastSummaryCountrySemiAnnualData(params)
            this.july_data = response.response.sales_data[0]
            this.august_data = response.response.sales_data[1]
            this.september_data = response.response.sales_data[2]
        },
        //API call to load forecast fourth quarter data
        async loadForecastSummaryFourthQuarterData(id, country){
            let params = {
                territory_id: id,
                country: country,
                between: "q4",
                period: "month"
            }
            let response = await this.getForecastSummaryCountrySemiAnnualData(params)
            this.october_data = response.response.sales_data[0]
            this.november_data = response.response.sales_data[1]
            this.december_data = response.response.sales_data[2]
        },
        loadTerritory(data){
            this.country_data = data
        },
        //API call to load forecast list data
        async loadForecastListData(){
            let params = {
                skip: 0,
                limit: 10
            }
            let response = await this.getForecastListData(params)
            this.forecast_list_data = response.response
            this.loadDashboardPage = false;
        },

    },
    computed: {
        userPermissions(){
                return this.$store.getters.userPermissions;
            },
        loggedInUser() {
            return this.$store.state.loggedInUser;
        },
    },
    mounted(){
        this.loadDashboardPage = true;
        this.currency = this.loggedInUser.currency.symbol;
        this.loadForcastSummary(),
        this.loadForecastListData()
    }
}
</script>
<style scoped>
.table-properties {
        border-collapse: collapse;
        width: 100%;
}
table thead th,
table tbody td {
    padding: 10px;
}
.create-forecast-btn{
    border-radius: 6px !important;
    background-color: #128807;
    cursor: pointer;
}
.expand-img{
    width: 18px;
    margin-bottom: 2px;
}
#forecastSummaryChartDiv{
    width: 100%;
    height: 500px;
}
#forecastYearlyData{
    width: 100%;
    height: 555px;
    max-height:555px;
    overflow-y:scroll !important;
}
.table-div{
    max-height: 400px;
}
.forecast-table{
    border: 1px solid lightgray;
    max-height: 400px;
}
.forecast-table thead{
    position: sticky;
    top: 0;
    background-color: #fff;
    color: #000 !important;
    font-size: 15px;
}
.forecast-table-row:hover{
    box-shadow: 0px 0px 6px darkgray;
}
.active{
    box-shadow: 0px 0px 6px darkgray;
}
.forecast-summary-table{
    min-height: 496px;
    width: 100%;
}
.forecast-summary-table-expand{
    max-height: 100%;
    min-height: 100%;
    margin-left: 35%;
}
.country-fullscreen{
    background-color: #fff;
    overflow: auto;
    height: 554px;
}
.forecast-summary-table thead{
    position: sticky;
    top: 0;
    background-color: #fff;
    font-size: 15px;
}
.forecast-period{
    width : 50%;
}
.target, .achieved{
    width: 25%;
}
.forecast-list-table{
    max-height: 500px;
    width: 100%;
}
.forecast-name{
    width: 20%
}
.team-lead, .sales-person, .territory, .sales-manager, .country, .status{
    width: 10%
}
.forecast-list-table thead{
    position: sticky;
    top: 0;
    background-color: #fff;
    font-size: 15px;
}
#legenddiv {
    height: 80px;
    width: 100%;
    position: absolute;
    bottom: 20px;
}
.connection-box{
    position: relative;
}
.connection-box::before{
    position: absolute;
    height: 36px;
    width: 16px;
    top: 3%;
    right: 0;
    background-color: #fff;
    content: '';
}
.connection-box-bottom{
    position: relative;
}
.connection-box-bottom::before{
    position: absolute;
    height: 36px;
    width: 16px;
    bottom: 8%;
    left: -16px;
    background-color: #fff;
    content: '';
}
.active-btn {
    color: #e5812c !important;
    text-transform: capitalize;
    font-weight :500;
}
.unachieve-btn {
    color: #f00f0f!important;
    text-transform: capitalize;
    font-weight :500;
}
.achieved-btn {
    color: #008a63 !important;
    text-transform: capitalize;
    font-weight :500;
}
.need_to_assign-btn {
    color: royalblue !important;
    text-transform: capitalize;
    font-weight :500;
}
.completed-btn {
    color: #008a63 !important;
    text-transform: capitalize;
    font-weight :500;
}
.unassigned-btn {
    color: royalblue !important;
    text-transform: capitalize;
    font-weight :500;
}
.forecast-table > th {
    color: #000 !important;
}
.forecast-country button{
    padding: 0px !important;
}
.box-radius{
    border-radius: 7px !important;
}
.country-size{
    font-size: 12px !important;
}
.summary-align{
    width: 50%!important;
    height: 100%!important;
    margin: auto!important;
    margin-top: 50px!important;
}
.align-text{
    margin-top: -30px !important;
}
.text-ellipsis{
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 150px;
    width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/SalesForecastDashboard.vue